import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import { i18nReady } from "@/i18n";
import "@/lib/apiAuth";
import App from "@/App";
import { initTrackingContext } from "@/lib/trackingContext";

initTrackingContext();

const root = ReactDOM.createRoot(document.getElementById("root"));
i18nReady.finally(() =>
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  ),
);
